var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-rectangle',{ref:"rectangle",attrs:{"color":_vm.shape.style.color,"l-style":_vm.shape.style,"fill":true,"fillOpacity":0,"options":{ interactive: true },"weight":_vm.weight,"bounds":_vm.shape.bounds},on:{"click":function($event){return _vm.$emit('click', $event)},"editable:dragend":_vm.onEditEnd,"editable:vertex:dragend":_vm.onEditEnd}})
}
var staticRenderFns = []

export { render, staticRenderFns }